import {map} from 'lodash';

import {Accordion, AccordionDetails, AccordionTitle, Icon} from 'components';
import {IpInfo} from 'types';

type Props = {
    ipInfos: IpInfo[];
    className?: string;
    renderCreatedBy: (eid: number) => React.ReactElement;
    renderCreatedAt: (date: Date) => string;
    onDelete: (index: number) => void;
}

export const IpGrid: React.FC<Props> = ({ipInfos, renderCreatedBy, renderCreatedAt, className, onDelete}) => (
    <div className={className}>
        {map(ipInfos, (ipInfo, index) => (
            <Accordion key={ipInfo.id || ipInfo.ip} className='tw-mb-2'>
                <AccordionTitle>
                    <div className='tw-flex tw-justify-between'>
                        {ipInfo.ip}
                        <Icon stopPropagation name='delete' color='alert' onClick={() => onDelete(index)} />
                    </div>
                </AccordionTitle>
                <AccordionDetails>
                    {renderCreatedBy(ipInfo.createdBy)}
                    <div className='tw-flex tw-items-center tw-mt-2'>
                        <Icon name='calendar' className='tw-ml-2 tw-mr-4' />
                        {renderCreatedAt(ipInfo.createdAt)}
                    </div>
                    {ipInfo.description &&
                        <div className='tw-flex tw-items-center tw-mt-2'>
                            <Icon name='chat' className='tw-ml-2 tw-mr-4' />
                            {ipInfo.description}
                        </div>}
                </AccordionDetails>
            </Accordion>
        ))}
    </div>
);